import React, { useEffect, useState, useMemo } from "react";
import BasicTable from "../Components/Global_Components/reacttable/table";
import { useSelector, useDispatch } from "react-redux";
import { sidebar, patientid, updatePatientTab, reportViewType, reportViewId } from "../Redux/Slice/rootSlice";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  getPrescriptionHistory,
  getPatientsRecords,
  getPatientBills,
  fetchPatientsReports,
} from "../Redux/Thunk/Actions";
import { useNavigate } from "react-router-dom";
import { fetchPatientsRecords, mainUrl } from "../Context/apiData";

function PatientRecords(props) {
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [dataCount, setDataCount] = useState();
  const [searchQuery, setSearchQuery] = useState("");
  const [tableHeaderData, setTableHeaderData] = useState([]);
  const selectedTab = useSelector((state) => state.counter.patientTab);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchHistoryData = async () => {
      // console.log("going in");
      const dataPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        patient_id: props.patientId,
        skipBranchFilter: true,
        // search: searchQuery,
      };
      if (props.typeshow == "prescription_specific") {
        dataPayload["prescription_id"] = props.prescriptionId;
      }
      // console.log(dataPayload, "dataPayload");
      props.loaderchange("true");
      const patentDetails = getPatientsRecords(dataPayload);
      const responsePatentDetails = await dispatch(patentDetails);
      console.log(responsePatentDetails, "this what");
      if (responsePatentDetails?.payload?.status?.code === 200) {
        setDataCount(responsePatentDetails.payload.total_count);
        setTableHeaderData(responsePatentDetails.payload.data.data);
        props.loaderchange("false");
      } else {
        props.loaderchange("false");
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      }
    };
    
    const fetchBillsData = async () => {
      // console.log("going in");
      const dataPayload = {
        page: dtpageindex,
        page_size: dtpagesize,
        patient_id: props.patientId,
        skipBranchFilter: true,
        // search: searchQuery,
      };

      if (props.typeshow == "prescription_specific") {
        dataPayload["prescription_id"] = props.prescriptionId;
      }
      // console.log(dataPayload, "dataPayload");
      props.loaderchange("true");
      const patientBills = getPatientBills(dataPayload.patient_id);
      const responsePatentDetails = await dispatch(patientBills);
      console.log(responsePatentDetails.payload.data);
      if (responsePatentDetails?.payload?.status?.code === 200) {
        setDataCount(responsePatentDetails.payload.total_count);
        setTableHeaderData(responsePatentDetails.payload.data);
        props.loaderchange("false");
      } else {
        props.loaderchange("false");
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      }
    };

    // const PatientRecords =()=>{
    //   setDataCount(responsePatentDetails.payload.total_count);
    //     setTableHeaderData(responsePatentDetails.payload.data);
    // }
    const fetchReportsData = async () => {
      const dataPayload = {
        // page: dtpageindex,
        // page_size: dtpagesize,
        patient_id: props.patientId,
        skipBranchFilter: true,
        // search: searchQuery,
      };

      // if (props.typeshow == "prescription_specific") {
      //   dataPayload["prescription_id"] = props.prescriptionId;
      // }
      console.log(dataPayload, "dataPayload............");
      props.loaderchange("true");
      const patientReport = fetchPatientsReports(dataPayload);
      const responsePatentDetails = await dispatch(patientReport);
      console.log(responsePatentDetails.payload.data, "this is me");
      if (responsePatentDetails?.payload?.status?.code === 200) {
        setDataCount(responsePatentDetails.payload.total_count);
        setTableHeaderData(responsePatentDetails.payload.data.data);
        props.loaderchange("false");
      } else {
        props.loaderchange("false");
        props.popupalert("true");
        props.popuptext("No Data Available");
        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      }
    };

    if (selectedTab === "History") {
      console.log("history");
      fetchHistoryData();
    } else if (selectedTab === "Patient Reports") {
      fetchReportsData();
    } else if (selectedTab === "Billing") {
      console.log("billing");
      fetchBillsData();
    }
  }, [selectedTab, props.table_reload_data]);

  const dropdownhandlechange = (e, event) => {
    if (e) {
      dispatch(reportViewType("Patient Reports"));
      navigate("/reportview");
      dispatch(reportViewId(e));
      // console.log(e,"id");
    }
  };
  // console.log(tableHeaderData);

  const handleViewChange = (e) => {
    navigate("/viewHistory");
  };

  const columns = useMemo(() => {
    if (selectedTab === "History") {
      return [
        {
          Header: "Date",
          accessor: "",
          Cell: (row) => {
            const final_value = row.row.original.created_at.slice(0, 10);
            const [year, month, day] = final_value.split("-");
            const formattedDate = `${day}-${month}-${year}`;
            // console.log(formattedDate);
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(formattedDate)}
                  >
                    {String(formattedDate)}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Time",
          accessor: "",
          Cell: (row) => {
            const date = new Date(row.row.original.created_at);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            let formattedHours = (hours % 12).toString().padStart(2, "0");
            formattedHours = formattedHours === "00" ? "12" : formattedHours;
            const formattedMinutes = minutes.toString().padStart(2, "0");
            const time = `${formattedHours}:${formattedMinutes} ${amOrPm}`;
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(time)}
                  >
                    {String(time)}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Prescription Type",
          accessor: "",
          Cell: (row) => {
            // console.log(row.row.original.username)
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(
                      row.row.original.prescription_id.template_type
                    )}
                  >
                    {String(row.row.original.prescription_id.template_type)}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Actions",
          accessor: "",
          Cell: (row) => {
            return (
              <div className="style">
                <a
                  target="_blank"
                  href={row.row.original.media_file}
                  style={{ textDecoration: "none" }}
                >
                  <button
                    type="button"
                    class="btn btn-danger btn-sm delete"
                    style={{ display: "flex", gap: "4px" }}
                    // onClick={(e) => handleViewChange(row.row.original.id, e)}
                  >
                    <i
                      // onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                      class="bi bi-eye-fill"
                    ></i>{" "}
                    View
                  </button>
                </a>
                {/* <a target="_blank" download="patient_record.pdf" href={row.row.original.media_file.split("/").splice(3,5).join("/")} style={{textDecoration:"none"}}> */}
                {/* <button
                type="button"
                class="btn btn-danger btn-sm delete"
                style={{ display: "flex", gap: "4px" }}
              >
                <i
                  class="bi bi-download"
                ></i>{" "}
                Download
              </button> */}
                {/* </a> */}
              </div>
            );
          },
        },
      ];
    }
    // else if(selectedTab==="Patient Records"){
    //   return [
    //     {
    //       Header: "Patient Name",
    //       accessor:""
    //     },
    //     {
    //       Header: "Patient ID",
    //       accessor: "patient_id",
    //     }
    //   ]
    // }
    else if (selectedTab === "Billing") {
      return [
        {
          Header: "Patient Name",
          accessor: "",
          Cell: (row) => {
            // console.log(row.row.original.username)
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(row.row.original.patient_name)}
                  >
                    {row.row.original.patient_id != null
                      ? row.row.original.patient_id.titles +
                        "." +
                        row.row.original.patient_id.first_name +
                        "   " +
                        row.row.original.patient_id.last_name
                      : "--"}
                  </div>
                </span>
              </>
            );
          },
        },

        {
          Header: "Created by",
          accessor: "",
          Cell: (row) => {
            // console.log(row.row.original.username)
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(
                      row.row.original.user_id.user_name
                    )}
                  >
                    {String(row.row.original.user_id.user_name)}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Date",
          accessor: "",
          Cell: (row) => {
            const final_value = row.row.original.created_at.slice(0, 10);
            const [year, month, day] = final_value.split("-");
            const formattedDate = `${day}-${month}-${year}`;
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(formattedDate)}
                  >
                    {String(formattedDate)}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Time",
          accessor: "",
          Cell: (row) => {
            // const inputDateTime = "2023-11-08T07:35:00.730468Z";
            // const date = new Date(inputDateTime);
            // const hours = date.getHours();
            // const minutes = date.getMinutes();
            // const formattedHours = hours.toString().padStart(2, "0");
            // const formattedMinutes = minutes.toString().padStart(2, "0");
            // const time = `${formattedHours}:${formattedMinutes}`;
            const date = new Date(row.row.original.created_at);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            let formattedHours = (hours % 12).toString().padStart(2, "0");
            formattedHours = formattedHours === "00" ? "12" : formattedHours;
            const formattedMinutes = minutes.toString().padStart(2, "0");
            const time = `${formattedHours}:${formattedMinutes} ${amOrPm}`;
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(time)}
                  >
                    {String(time)}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Notes",
          accessor: "",
          Cell: (row) => {
            // console.log(row.row.original.username)
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(row.row.original.description)}
                  >
                    {row.row.original.description == null ||
                    row.row.original.description.length == 0
                      ? "--"
                      : row.row.original.description}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Total Bill",
          accessor: "",
          Cell: (row) => {
            // console.log(row.row.original.username)
            return (
              <>
                {row.row.original.bill_price}
                {/* {todaysTotal} */}
              </>
            );
          },
        },
      ];
    } else if (selectedTab === "Patient Reports") {
      return [
        {
          Header: "Patient Name",
          accessor: "",
          Cell: (row) => {
            // console.log(row.row.original.username)
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(row.row.original.patient_name)}
                  >
                    {row.row.original.patient_id != null
                      ? row.row.original.patient_id.titles +
                        "." +
                        row.row.original.patient_id.first_name +
                        row.row.original.patient_id.last_name
                      : "--"}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Created by",
          accessor: "",
          Cell: (row) => {
            // console.log(row.row.original.username)
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(
                      row.row.original.user_id.user_name
                    )}
                  >
                    {String(row.row.original.user_id.user_name)}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Date",
          accessor: "",
          Cell: (row) => {
            const final_value = row.row.original.created_at.slice(0, 10);
            const [year, month, day] = final_value.split("-");
            const formattedDate = `${day}-${month}-${year}`;
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(formattedDate)}
                  >
                    {String(formattedDate)}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Time",
          accessor: "",
          Cell: (row) => {
            // const inputDateTime = "2023-11-08T07:35:00.730468Z";
            // const date = new Date(inputDateTime);
            // const hours = date.getHours();
            // const minutes = date.getMinutes();
            // const formattedHours = hours.toString().padStart(2, "0");
            // const formattedMinutes = minutes.toString().padStart(2, "0");
            // const time = `${formattedHours}:${formattedMinutes}`;
            const date = new Date(row.row.original.created_at);
            const hours = date.getHours();
            const minutes = date.getMinutes();
            const amOrPm = hours >= 12 ? "PM" : "AM";
            let formattedHours = (hours % 12).toString().padStart(2, "0");
            formattedHours = formattedHours === "00" ? "12" : formattedHours;
            const formattedMinutes = minutes.toString().padStart(2, "0");
            const time = `${formattedHours}:${formattedMinutes} ${amOrPm}`;
            return (
              <>
                <span>
                  <div
                    style={{ marginTop: "3px" }}
                    data-tooltip-id="my-tooltip"
                    data-tooltip-content={String(time)}
                  >
                    {String(time)}
                  </div>
                </span>
              </>
            );
          },
        },
        {
          Header: "Report type",
          accessor: "",
          Cell: (row) => {
            // console.log(row.row.original.username)
            return (
              <>
                <span>{row.row.original.template_type}</span>
              </>
            );
          },
        },
        {
          Header: "Actions",
          accessor: "",
          Cell: (row) => {
            return (
              <div className="style">
                {/* <button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  style={{ display: "flex", gap: "4px" }}
                  onClick={(e) => editPatientPopup(row.row.original.id, e)}
                >
                  <i
                    onClick={(e) => editPatientPopup(row.row.original.id, e)}
                    class="bi bi-pencil"
                  ></i>{" "}
                  Edit
                </button> */}
                {row.row.original.template_type==="Added Report"?(
                  <a style={{textDecoration:"none"}} target="_blank" href={mainUrl + row.row.original.files}>
                  <button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  style={{ display: "flex", gap: "4px" }}
                  // onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i
                    // onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                    class="bi bi-eye-fill"
                  ></i>{" "}
                  View
                </button>
                </a>
                ):(<button
                  type="button"
                  class="btn btn-danger btn-sm delete"
                  style={{ display: "flex", gap: "4px" }}
                  onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                >
                  <i
                    // onClick={(e) => dropdownhandlechange(row.row.original.id, e)}
                    class="bi bi-eye-fill"
                  ></i>{" "}
                  View
                </button>)}
                
              </div>
            );
          },
        },
      ];
    }
  }, [selectedTab, tableHeaderData]);
  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };

  return (
    <>
      <div className="pageBody" style={{ width: "100%" }}>
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="table-patient">
                  <BasicTable
                    columns={columns}
                    data={tableHeaderData}
                    pagesize={pagesize}
                    pageindex={pageindex}
                    dtpagesize={dtpagesize}
                    dtpageindex={dtpageindex}
                    dataCount={dataCount}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ReactTooltip
          id="my-tooltip"
          arrowColor="transparent"
          place="bottom-start"
          delayShow={200}
          style={{
            backgroundColor: "#707070",
            fontSize: "10px",
            textAlign: "center",
            padding: "5px",
            fontWeight: 400,
          }}
        />
      </div>
    </>
  );
}

export default PatientRecords;
